module.exports = __webpack_public_path__ + "static/media/HCMM746.3c4a691b.jpg";